"use client";

import { useEffect } from "react";

const COUNT_PREFIX = /^\(\d+\) /;

/**
 * Puts `(n) ` in front of the tab title while the tab is hidden and support has
 * unread replies, so a planner in another tab sees it in the tab strip. Strips
 * it again on read or on return. It edits whatever the title is at the time
 * rather than restoring a saved copy, so a page that renamed the tab meanwhile
 * keeps its new name.
 *
 * @param unreadCount - Unread support replies.
 * @param isVisible - Whether the tab is visible.
 */
export const useUnreadTitle = (unreadCount: number, isVisible: boolean) => {
  useEffect(() => {
    const bare = document.title.replace(COUNT_PREFIX, "");
    document.title = !isVisible && unreadCount > 0 ? `(${unreadCount}) ${bare}` : bare;
  }, [unreadCount, isVisible]);

  useEffect(() => () => void (document.title = document.title.replace(COUNT_PREFIX, "")), []);
};
